export const journey = [
  {
    id: 0,
    img: 'https://mithilparmar-portfolio.s3.us-west-1.amazonaws.com/assets/images/infonikka.png',
    role: 'Software Engineer',
    company: 'Infonikka',
    date: 'May 2023 – Present',
    desc: [
      'Own Python-first data & ML features: ETL pipelines processing 100K+ rows/day; Flask APIs with <500ms p95',
      'Automated analytics and reporting; cut manual ops by 30+ hours/month',
      'LLM integrations (summarization, parsing) to unlock faster decisions for product/ops',
      'CI/CD with GitHub Actions + testing; daily releases with higher reliability',
      'Observability via ELK; proactive alerting and KPI dashboards for teams'
    ],
    skills: [
      'Python', 'Flask', 'Pandas', 'NumPy', 'SQL', 'PostgreSQL',
      'Airflow', 'Redis', 'AWS (S3, Lambda, Glue)',
      'LLM Integrations (HuggingFace)', 'ELK', 'GitHub Actions', 'Docker', 'REST APIs'
    ],
    doc: ''
  },
  {
    id: 1,
    img: 'https://mithilparmar-portfolio.s3.us-west-1.amazonaws.com/assets/images/apexon.png',
    role: 'Data Engineer Intern',
    company: 'Apexon',
    date: 'Jun 2022 – Aug 2022',
    desc: [
      'Built PySpark + AWS Glue pipelines on multi-million record healthcare datasets',
      'Optimized SQL transforms; ~10% faster jobs and leaner model inputs',
      'Published Tableau dashboards for KPI monitoring and stakeholder visibility'
    ],
    skills: ['Python', 'PySpark', 'AWS Glue', 'SQL', 'PostgreSQL', 'Tableau'],
    doc: ''
  },
  {
    id: 2,
    img: 'https://mithilparmar-portfolio.s3.us-west-1.amazonaws.com/assets/images/sjsu.png',
    role: 'M.S. in Artificial Intelligence',
    company: 'San José State University',
    date: 'Aug 2021 – May 2023',
    desc: [
      'Specialized in data mining, applied ML, and model-driven systems',
      'Capstone: SR-GAN video compression (≈4× compression, ~5% lower RMSE vs OpenCV)',
      'Projects: real-time emotion classification; ROUGE-validated summarizer (DistilBART/T5)'
    ],
    techstack: ['Python', 'TensorFlow', 'SR-GAN', 'HuggingFace', 'Streamlit', 'VGG19'],
    grades: ['3.61 GPA']
  },
  {
    id: 3,
    img: 'https://mithilparmar-portfolio.s3.us-west-1.amazonaws.com/assets/images/infonikka.png',
    role: 'Software Developer (Earlier Stint)',
    company: 'Infonikka',
    date: 'Jan 2019 – Jun 2021',
    desc: [
      'Shipped client-facing web features; refactored legacy modules for speed and maintainability',
      'Applied Agile delivery with rapid feedback loops to improve usability',
      'Partnered with cross-functional teams to align features to user needs'
    ],
    skills: ['Python', 'React', 'Angular', 'Cassandra', 'Agile'],
    doc: ''
  },
  {
    id: 4,
    img: 'https://mithilparmar-portfolio.s3.us-west-1.amazonaws.com/assets/images/abm_systems.png',
    role: 'AI Intern',
    company: 'ABM Systems, Inc.',
    date: 'Dec 2018 – Jan 2019',
    desc: [
      'Explored ML for industrial automation (PLC/SCADA) with HMI-linked monitoring',
      'Prototyped anomaly-detection concepts to inform real-time controls'
    ],
    skills: ['Machine Learning', 'SCADA', 'HMI', 'Python']
  },
  {
    id: 5,
    img: 'https://mithilparmar-portfolio.s3.us-west-1.amazonaws.com/assets/images/srm.png',
    role: 'B.Tech in Information Technology',
    company: 'SRM Institute of Science and Technology',
    date: 'Jun 2016 – May 2020',
    desc: [
      'Core CS: data structures, algorithms, software design',
      'Shipped full-stack projects; applied ML capstone with practical deployment focus'
    ],
    techstack: ['Java', 'Python', 'MySQL', 'JavaScript', 'HTML/CSS', 'Node.js'],
    grades: ['3.54 GPA'],
    doc: ''
  }
];
